import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import auth from "../middlewares/auth";
import checkAdmin from "../middlewares/admin";
import DeviceNotAuthorized from "../views/DeviceNotAuthorized.vue";
import locacoesApi from "@/services/locacoes";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/device_not_authorized",
    name: "deviceNotAuthorized",
    component: DeviceNotAuthorized
  },
  {
    path: "/",
    name: "home",
    component: Home,
    children: [
      {
        path: "/",
        name: "dashboard",
        component: () => import("../views/Dashboard.vue")
      },
      {
        path: "clientes",
        name: "clients",
        component: () => import("../views/Clients.vue")
      },
      {
        path: "clientes/:id",
        name: "pagina_cliente",
        component: () => import("../views/PaginaCliente.vue")
      },
      {
        path: "produtos",
        name: "products",
        component: () => import("../views/Products.vue")
      },
      {
        path: "users",
        name: "users",
        component: () => import("../views/Users.vue"),
        beforeEnter: checkAdmin
      },
      {
        path: "perfil",
        name: "perfil",
        component: () => import("../views/Profile.vue")
      },
      {
        path: "/pedidos",
        name: "pedidos",
        component: () => import("../views/Pedidos.vue")
      },
      {
        path: "/devolucoes/nova",
        name: "nova_devolucao",
        component: () => import("../views/NovaDevolucaoForm.vue")
      },
      {
        path: "/devolucoes",
        name: "devolucoes",
        component: () => import("../views/Devolucoes.vue")
      },
      {
        path: "/devolucoes/:numero",
        name: "devolucao_page",
        component: () => import("../views/DevolucaoPage.vue")
      },
      {
        path: "/movimentações-ficha",
        name: "movimentacoes-ficha",
        beforeEnter: checkAdmin,
        component: () => import("../views/MovimentacoesFichaPage.vue")
      },
      {
        path: "/relatorios/vendas-por-forma-de-pagamento",
        name: "relatorio-vendas-por-forma-de-pagamento",
        beforeEnter: checkAdmin,
        component: () =>
          import("../views/RelatorioVendasPorFormaDePagamento.vue")
      },
      {
        path: "/sales/new",
        name: "new_sale",
        component: () => import("../views/SaleForm.vue")
      },
      {
        path: "/pedidos/new",
        name: "new_pedido",
        component: () => import("../views/PedidoForm.vue")
      },
      {
        path: "/pedidos/:numero",
        name: "edit_pedido",
        component: () => import("../views/PedidoForm.vue")
      },
      {
        path: "relogio_de_ponto",
        name: "relogio_de_ponto",
        component: () => import("../views/RelogioDePonto.vue")
      },
      {
        path: "authorized_devices",
        name: "authorized_devices",
        component: () => import("../views/AuthorizedDevices.vue"),
        beforeEnter: checkAdmin
      },
      {
        path: "/locações/estoque",
        name: "locacao_estoque",
        component: () => import("../views/locações/Estoque.vue")
      },
      {
        path: "/locações/locais_de_estoque",
        name: "locais_de_estoques_page",
        component: () => import("../views/locações/LocalEstoquesPage.vue")
      },
      {
        path: "/locações/locais_de_estoque/:id",
        name: "locais_de_estoque_page",
        props: true,
        component: () => import("../views/locações/LocalEstoquePage.vue"),
        beforeEnter: async (to, from, next) => {
          try {
            const localEstoque = await locacoesApi.locais_de_estoque.exibir(
              to.params.id
            );

            to.params.localEstoque = localEstoque;

            next();
          } catch (error) {
            next({
              name: "locais_de_estoques_page"
            });
          }
        },
        beforeRouteUpdate: async (to, from, next) => {
          try {
            const localEstoque = await locacoesApi.locais_de_estoque.exibir(
              to.params.id
            );

            to.params.localEstoque = localEstoque;

            next();
          } catch (error) {
            next({
              name: "locais_de_estoques_page"
            });
          }
        }
      },
      {
        path: "/locações",
        name: "locacoes_page",
        component: () => import("../views/locações/LocacoesPage.vue")
      },
      {
        path: "/locações/transferencias",
        name: "transferencias_page",
        component: () => import("../views/locações/TransferenciasPage.vue")
      },
      {
        path: "/locações/transportes",
        component: () =>
          import("../views/locações/Transportes/TransportesPage.vue"),
        children: [
          {
            path: "",
            redirect: {
              name: "locacoes-transportes-recolhimentos"
            }
          },
          {
            path: "todos",
            name: "locacoes-transportes-todos",
            component: () =>
              import("../views/locações/Transportes/TodosTransportesPage.vue")
          },
          {
            path: "entregas",
            name: "locacoes-transportes-entregas",
            component: () =>
              import("../views/locações/Transportes/EntregasPage.vue")
          },
          {
            path: "recolhimentos",
            name: "locacoes-transportes-recolhimentos",
            component: () =>
              import("../views/locações/Transportes/RecolhimentosPage.vue")
          },
          {
            path: "ordens",
            component: () =>
              import("../views/locações/Transportes/OrdensPage.vue")
          }
        ]
      },
      {
        path: "locações/ordens_transporte",
        name: "locacoes-ordens-transporte-listagem",
        component: () =>
          import(
            "../views/locações/OrdensTransporte/OrdensTransporteListagemPage.vue"
          )
      },
      {
        path: "locações/ordens_transporte/:codigo",
        name: "locacoes-ordens-transporte",
        props: true,
        component: () =>
          import("../views/locações/OrdensTransporte/OrdensTransportePage.vue")
      },
      {
        path: "/locações/pagamentos",
        name: "locacoes_pagamentos_page",
        props: true,
        component: () =>
          import("../views/locações/Pagamentos/PagamentosPage.vue")
      },
      {
        path: "/locações/pagamentos_retirados",
        name: "locacoes_pagamentos_retirados_page",
        props: true,
        component: () =>
          import("../views/locações/Pagamentos/RetiradosPage.vue")
      },
      {
        path: "/locações/pagamentos_retirados/:id",
        name: "locacoes_pagamentos_retirados_detalhes_page",
        props: true,
        component: () =>
          import("../views/locações/Pagamentos/RetiradoDetalhePage.vue")
      },
      {
        path: "/locações/relatorios",
        name: "locacoes_relatorios",
        props: true,
        component: () =>
          import("../views/locações/Relatorios/LocacaoRelatorios.vue")
      },
      {
        path: "/locações/relatorios/pagamentos_recebidos",
        name: "locacoes_relatorios_pagamentos_recebidos",
        props: true,
        component: () =>
          import(
            "../views/locações/Relatorios/PagamentosRecebidosRelatorio.vue"
          )
      },
      {
        path: "/locações/:codigo",
        name: "locacoes_locacao_page",
        props: true,
        component: () => import("../views/locações/LocacaoPage.vue")
      },
      {
        path: "/locações/:codigo/novo_endereco",
        name: "locacoes_locacao_novo_endereco",
        props: true,
        component: () => import("../views/locações/LocacaoNovoEnderecoPage.vue")
      }
    ]
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "*",
    component: Home,
    beforeEnter: (to, from, next) => {
      next("/");
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
